import React from 'react';
import { useStyles } from '../styles';
import RewardsTable from './components/RewardsTable';
import { LabelImportantOutlined } from '@material-ui/icons';

const GamificationRewards = () => {

    const classes = useStyles();
    
    return (
        <div className={classes.rewardAdminContainer}>
            <RewardsTable />
        </div>
    )
}

export default GamificationRewards;